<template>
  <v-autocomplete
    v-model="modelValue"
    :items="cellKindsItems"
    chips
    small-chips
    deletable-chips
    multiple
    label="Cell Kinds:"
  />
</template>

<script>
export default {
  name: "r-cell-kinds-select",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      cellKindsItems: [
        "none",
        "road",
        "ground",
        "water",
        "barrier",
        "ground_road_closed",
        "creature_air",
        "creature_fire",
        "creature_earth",
        "creature_water"
      ]
    };
  },

  computed: {
    modelValue: {
      get() {
        return Array.isArray(this.value) ? this.value.map(String) : [];
      },
      set(value) {
        this.$emit("input", Array.isArray(value) ? value.map(String) : []);
      }
    }
  }
};
</script>
